import React, { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { supabase } from '../../config/supabaseClient';

const AuthCallback = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const [error, setError] = useState(null);

  useEffect(() => {
    const handleCallback = async () => {
      try {
        console.log('AuthCallback: Starting auth callback process');
        
        // Check if this is a password reset callback
        const type = searchParams.get('type');
        
        console.log('AuthCallback: URL params:', { type });
        
        // If this is a password reset callback, redirect to password reset page
        if (type === 'recovery') {
          console.log('AuthCallback: Password reset callback detected, redirecting to reset page');
          navigate('/reset-password', { replace: true });
          return;
        }
        
        // For all other auth callbacks, let Supabase handle the session automatically
        // and then redirect based on the result
        const { data, error } = await supabase.auth.getSession();
        
        if (error) {
          console.error('AuthCallback: Session error:', error);
          throw error;
        }

        console.log('AuthCallback: Session data:', data);
        
        if (data?.session?.user) {
          console.log('AuthCallback: User verified successfully, redirecting to home');
          
          // Check if this was a fresh email verification
          const wasJustVerified = localStorage.getItem('email_verification_pending');
          if (wasJustVerified && data.session.user.email_confirmed_at) {
            console.log('AuthCallback: Fresh email verification detected, triggering welcome email...');
            
            // Send welcome email immediately
            try {
              const response = await fetch(
                `${process.env.REACT_APP_SUPABASE_URL}/functions/v1/quick-task`,
                {
                  method: 'POST',
                  headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${data.session.access_token}`,
                  },
                  body: JSON.stringify({})
                }
              );

              const result = await response.json();
              if (response.ok && result.success) {
                console.log('AuthCallback: Welcome email sent successfully');
              } else {
                console.error('AuthCallback: Failed to send welcome email:', result.error);
              }
            } catch (emailError) {
              console.error('AuthCallback: Error sending welcome email:', emailError);
            }
            
            // Clear the pending verification flag
            localStorage.removeItem('email_verification_pending');
          }
          
          // Redirect to home page on success
          navigate('/', { replace: true });
        } else {
          console.log('AuthCallback: No session found, redirecting to login');
          // If no session, redirect to login
          navigate('/auth/login', { replace: true });
        }
      } catch (err) {
        console.error('AuthCallback: Error in auth callback:', err);
        setError(err.message);
      }
    };

    handleCallback();
  }, [navigate, searchParams]);

  if (error) {
    return (
      <div className="min-h-screen flex flex-col items-center justify-center bg-[#F4FFF7] p-4">
        <div className="max-w-md w-full bg-white rounded-lg shadow-xl p-8 text-center">
          <h2 className="text-2xl font-bold text-red-600 mb-4">Verification Error</h2>
          <p className="text-gray-600 mb-4">{error}</p>
          <button
            onClick={() => navigate('/auth/login')}
            className="px-4 py-2 bg-[#0D9488] text-white rounded hover:bg-[#0A7C72] transition-colors"
          >
            Back to Login
          </button>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-[#F4FFF7]">
      <div className="max-w-md w-full bg-white rounded-lg shadow-xl p-8 text-center">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-[#0D9488] mx-auto mb-4"></div>
        <h2 className="text-xl font-semibold text-gray-700">Verifying your email...</h2>
        <p className="text-gray-500 mt-2">Please wait while we complete the verification process.</p>
      </div>
    </div>
  );
};

export default AuthCallback; 